<template>
  <div class="date-selector">
    <div class="dates">
      <div>
        <v-menu
          v-model="dateMenu1"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="date1Formatted"
              :label="'from' | lang | lowercase"
              readonly
              hide-details
              prepend-icon="mdi-calendar"
              v-on="on"
              @click:prepend="dateMenu1=true"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="date1"
            :max="date2"
            first-day-of-week="1"
            @input="setDate()"></v-date-picker>
        </v-menu>
      </div>
      <div>
        <v-menu
          v-model="dateMenu2"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="date2Formatted"
              :label="'to' | lang | lowercase"
              readonly
              hide-details
              prepend-icon="mdi-calendar"
              v-on="on"
              @click:prepend="dateMenu2=true"
            ></v-text-field>
          </template>
          <v-date-picker
            :min="date1"
            v-model="date2"
            first-day-of-week="1"
            @input="setDate()"></v-date-picker>
        </v-menu>
      </div>
    </div>
    <div class="presets caption">
      <span class="preset"
            v-for="preset of displayPresets"
            :key="preset.code"
            @click="setPreset(preset)">
        {{ preset.title }}
      </span>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone';
import langFilter from '@/filters/langFilter';

export default {
  name: 'DatePeriodSelect',
  props: ['presets', 'initPreset', 'dateFrom', 'dateTo'],
  data: () => ({
    date1: null,
    date2: null,
    dateMenu1: false,
    dateMenu2: false,
  }),
  computed: {
    presetsList() {
      return [
        {
          code: '-month',
          title: langFilter('month'),
          getDates() {
            return {
              date1: moment().add(-1, 'month').add(1, 'day'),
              date2: moment(),
            };
          },
        },
        {
          code: '-3month',
          title: langFilter('3 months'),
          getDates() {
            return {
              date1: moment().add(-3, 'month').add(1, 'day'),
              date2: moment(),
            };
          },
        },
        {
          code: '-week',
          title: langFilter('week'),
          getDates() {
            return {
              date1: moment().add(-7, 'day'),
              date2: moment(),
            };
          },
        },
        {
          code: 'yesterday',
          title: langFilter('yesterday'),
          getDates() {
            return {
              date1: moment().subtract(1, 'day'),
              date2: moment().subtract(1, 'day'),
            };
          },
        },
        {
          code: 'today',
          title: langFilter('today'),
          getDates() {
            return {
              date1: moment(),
              date2: moment(),
            };
          },
        },
        {
          code: 'tomorrow',
          title: langFilter('tomorrow'),
          getDates() {
            return {
              date1: moment().add(1, 'day'),
              date2: moment().add(1, 'day'),
            };
          },
        },
        {
          code: '+week',
          title: langFilter('week'),
          getDates() {
            return {
              date1: moment(),
              date2: moment().add(7, 'day'),
            };
          },
        },
        {
          code: '+month',
          title: langFilter('month'),
          getDates() {
            return {
              date1: moment(),
              date2: moment().add(1, 'month').subtract(1, 'day'),
            };
          },
        },
      ];
    },
    displayPresets() {
      if (!this.presets) {
        return [];
      }
      return this.presetsList.filter(set => this.presets.includes(set.code));
    },
    date1Formatted() {
      return this.date1 ? moment(this.date1).format('DD.MM.YYYY') : '';
    },
    date2Formatted() {
      return this.date2 ? moment(this.date2).format('DD.MM.YYYY') : '';
    },
  },
  methods: {
    setDate() {
      this.dateMenu1 = false;
      this.dateMenu2 = false;
      this.$emit('input', this.date1, this.date2);
    },
    setPreset(preset) {
      const { date1, date2 } = preset.getDates();
      const changed = (this.date1 !== date1.format('YYYY-MM-DD') || this.date2 !== date2.format('YYYY-MM-DD'));
      this.date1 = date1.format('YYYY-MM-DD');
      this.date2 = date2.format('YYYY-MM-DD');
      if (changed) {
        this.setDate();
      }
    },
  },
  created() {
    if (this.dateFrom) {
      this.date1 = this.dateFrom;
    }
    if (this.dateTo) {
      this.date2 = this.dateTo;
    }
    if (this.initPreset) {
      const { initPreset } = this;
      let preset = this.presetsList.find(set => set.code === initPreset);
      if (!preset) {
        preset = this.presetsList.find(set => set.code === 'today');
      }
      this.setPreset(preset);
    }
  },
};
</script>

<style scoped lang="less">
  .date-selector {
    width: 245px;

    .dates {
      & > div {
        width: 120px;
        display: inline-block;
        margin-right: 1px;
      }
    }

    .presets {
      display: flex;
      color: #555555;
      justify-content: space-between;

      .preset {
        cursor: pointer;
      }
    }
  }
</style>
